// Sticky Add-to-Cart Bar JS
(function(){
  var stickyBar = document.getElementById('sticky-atc-bar');
  var mainATC = document.getElementById('AddToCart');
  var priceEl = document.getElementById('sticky-atc-price');
  var variantSelect = document.getElementById('ProductSelect-' + stickyBar.closest('[data-section-id]').getAttribute('data-section-id'));
  var qtySelect = document.getElementById('quantity');
    var qtyCircle = document.getElementById('sticky-atc-qty-circle');

  function updateStickyBar() {
    if (!variantSelect || !priceEl) return;
    var selectedOption = variantSelect.options[variantSelect.selectedIndex];
    var priceText = selectedOption.text.match(/([\$€£][\d,.]+)/);
    priceEl.textContent = priceText ? priceText[1] : priceEl.textContent;
      if (qtySelect && qtyCircle) {
        var qty = parseInt(qtySelect.value, 10) || 1;
        qtyCircle.textContent = 'x' + qty;
      }
  }

  function isMainATCVisible() {
    var rect = mainATC.getBoundingClientRect();
    return rect.top >= 0;
  }

  function toggleStickyBar() {
    if (!mainATC) return;
    stickyBar.style.display = isMainATCVisible() ? 'none' : 'block';
  }

  // Sync price on variant change
  if (variantSelect) {
    variantSelect.addEventListener('change', updateStickyBar);
    updateStickyBar();
  }
    if (qtySelect && qtyCircle) {
      qtySelect.addEventListener('input', updateStickyBar);
      updateStickyBar();
      qtyCircle.addEventListener('click', function(){
        qtySelect.scrollIntoView({ behavior: 'smooth', block: 'center' });
        qtySelect.focus();
      });
    }

  // Show/hide sticky bar on scroll
  window.addEventListener('scroll', toggleStickyBar);
  window.addEventListener('resize', toggleStickyBar);
  document.addEventListener('DOMContentLoaded', toggleStickyBar);

  // Add to cart logic
    document.getElementById('sticky-atc-btn').addEventListener('click', function(){
        var productForm = mainATC && mainATC.closest('form');
        console.log('Sticky ATC clicked, submitting form:', productForm);
      if (productForm) {
        productForm.submit();
        }
    });
})();
